module.exports = __webpack_public_path__ + "img/users.693dcd52.png";